// extracted by mini-css-extract-plugin
export default {"header":"VV4E8l","column":"KB8JSk"};